import { COLORS } from "@coeff/utils";
import { Switch as SwitchAD } from "antd";
import styled from "styled-components";

const StyledSwitch = styled(SwitchAD)`
  &.ant-switch-checked {
    background-color: ${COLORS.coeblue4};
  }
`;

export const Switch = StyledSwitch;
